"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.map = exports.wrapHTML = exports.nothing = exports.fromJSX = void 0;
const React = __importStar(require("react"));
/** Creates a widget from a cont -> JSX.Element */
const fromJSX = (w) => ({
    run: w,
    wrapHTML: function (f) { return (0, exports.wrapHTML)(f)(this); },
    map: function (f) { return (0, exports.map)(f)(this); },
    never: function () { return never(this); }
});
exports.fromJSX = fromJSX;
const nothing = () => (0, exports.fromJSX)(_ => React.createElement(React.Fragment, null));
exports.nothing = nothing;
const never = (inner_widget) => (0, exports.fromJSX)((_) => inner_widget.run(_ => { }));
const wrapHTML = (wrap) => widget_a => (0, exports.fromJSX)((on_done) => wrap(widget_a.run(res_a => on_done(res_a))));
exports.wrapHTML = wrapHTML;
const map = (f) => widget_a => (0, exports.fromJSX)((on_done_b) => widget_a.run(res_a => on_done_b(f(res_a))));
exports.map = map;
